export default class DiagramConst {
  // This needs to stay identical to WorkflowConst in workflow_steps_steps.rb in order for tests
  // to calculate the location to click correctly

  static readonly FontFamily = 'Nunito';

  static readonly StartLineExtraWidth = 2000;

  // Arrows
  static readonly ArrowPointerLength = 8;
  static readonly ArrowPointerWidth = 12;
  static readonly ArrowPointerOffset = 20;

  // Steps
  static readonly StepHeight: number;
  static readonly StepWidth: number;
  static readonly StepBorderWidth = 1;

  static readonly StepPaddingOffset = 500;

  // Actions
  static readonly ActionHeight = 50;

  static readonly ArrowComponentHeight = 75;

  // Arrow with plus
  static readonly PlusLineLength = 55;
  static readonly PlusLength = 16;
  static readonly LineStrokeWidth = 4;

  // DEFAULTS - to be set in subclasses
  // Start
  static readonly StartHeight: number;
  static readonly StartStrokeWidth: number;
  static readonly StartYOffset: number;
  static readonly StartCornerRadius: number;
  static readonly StartArrowLength: number;

  // End Step
  static readonly EndStepHeight: number;
  static readonly EndStepWidth: number;
  static readonly EndStepBorderWidth: number;
  static readonly EndStepPaddingOffset: number;

  static readonly DisconnectedStepYOffset: number;

  // DEFAULTS END
}